// Agent Actions
export const FETCH_AGENTS_REQUEST = 'agentHub/FETCH_AGENTS_REQUEST';
export const FETCH_AGENTS_SUCCESS = 'agentHub/FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_FAILURE = 'agentHub/FETCH_AGENTS_FAILURE';

export const SELECT_AGENT = 'agentHub/SELECT_AGENT';
export const SET_SEARCH_TERM = 'agentHub/SET_SEARCH_TERM';
export const SET_FILTER_STATUS = 'agentHub/SET_FILTER_STATUS';

export const FETCH_CONVERSATIONS_REQUEST = 'agentHub/FETCH_CONVERSATIONS_REQUEST';
export const FETCH_CONVERSATIONS_SUCCESS = 'agentHub/FETCH_CONVERSATIONS_SUCCESS';
export const FETCH_CONVERSATIONS_FAILURE = 'agentHub/FETCH_CONVERSATIONS_FAILURE';
export const SELECT_CONVERSATION = 'agentHub/SELECT_CONVERSATION';

export const FETCH_CONVERSATION_MESSAGES_REQUEST = 'agentHub/FETCH_CONVERSATION_MESSAGES_REQUEST';
export const FETCH_CONVERSATION_MESSAGES_SUCCESS = 'agentHub/FETCH_CONVERSATION_MESSAGES_SUCCESS';
export const FETCH_CONVERSATION_MESSAGES_FAILURE = 'agentHub/FETCH_CONVERSATION_MESSAGES_FAILURE';

export const TOGGLE_MOBILE_MENU = 'agentHub/TOGGLE_MOBILE_MENU';
export const TOGGLE_COLLAPSE = 'agentHub/TOGGLE_COLLAPSE';
export const NAVIGATE_TO_VIEW = 'agentHub/NAVIGATE_TO_VIEW';
export const SET_DARK_MODE = 'agentHub/SET_DARK_MODE';

export const SET_INPUT_MESSAGE = 'agentHub/SET_INPUT_MESSAGE';
export const SEND_MESSAGE = 'agentHub/SEND_MESSAGE';
export const RECEIVE_MESSAGE = 'agentHub/RECEIVE_MESSAGE';
export const SET_IS_TYPING = 'agentHub/SET_IS_TYPING';
export const RESET_CHAT = 'agentHub/RESET_CHAT';
export const SET_SESSION_ID = 'agentHub/SET_SESSION_ID';

export const WS_CONNECT_REQUEST = 'agentHub/WS_CONNECT_REQUEST';
export const WS_CONNECT_SUCCESS = 'agentHub/WS_CONNECT_SUCCESS';
export const WS_CONNECT_FAILURE = 'agentHub/WS_CONNECT_FAILURE';
export const WS_DISCONNECT = 'agentHub/WS_DISCONNECT';
export const WS_MESSAGE_CHUNK = 'agentHub/WS_MESSAGE_CHUNK';
export const WS_MESSAGE_COMPLETE = 'agentHub/WS_MESSAGE_COMPLETE';
export const WS_ERROR = 'agentHub/WS_ERROR';

export const SET_ARTIFACTS = 'agentHub/SET_ARTIFACTS';
export const ADD_ARTIFACT = 'agentHub/ADD_ARTIFACT';
export const TOGGLE_ARTIFACT_PANEL = 'agentHub/TOGGLE_ARTIFACT_PANEL';
export const CLEAR_ARTIFACTS = 'agentHub/CLEAR_ARTIFACTS';
export const SET_SELECTED_ARTIFACT = 'agentHub/SET_SELECTED_ARTIFACT';
